import { Injectable } from '@angular/core';

/**
 * Ermöglicht Portalkomponenten Ihren State zu speichern,
 * damit bei erneutem Aufruf der Portalseite (z.b. Bookmark) der Zustand wiederhergestellt wird.
 *
 * Die Default-Implementierung speichert im LocalStorage. Dies primär zu Entwicklungszwecken (npm start) gedacht.
 */
@Injectable()
export abstract class IPortalComponentStateService {
    /**
     * Speichert den State eine Komponente.
     *
     * @param id Identifiziert die Komponente eindeutig, um ihren State von dem anderer Komponenten unterscheiden zu können.
     * In der Regel muss diese ID in der Portalkomponente über ein PortalComponentInput konfigurierbar gemacht werden,
     * damit auch mehr mehrmaliger Verwendung der Komponente auf einer Portalseite die Eindeutigkeit gewahrt bleibt.
     * Wenn nullish , erfolgt keine Speicherung des State.
     */
    public saveState(componentId: string, state: ComponentState) {
        if (componentId && state) {
            localStorage.setItem('componentState_' + componentId, JSON.stringify(state));
        }
    }

    /**
     * Lädt den State eine Komponente.
     *
     * @param id Identifiziert die Komponente eindeutig, um ihren State von dem anderer Komponenten unterscheiden zu können.
     * Wenn nullish , wird ein leeres Objekt zurückgegeben.
     */
    public loadState(componentId: string): ComponentState {
        if (componentId) {
            const stateJson = localStorage.getItem('componentState_' + componentId);
            return stateJson && JSON.parse(stateJson) || {};
        } else {
            return {};
        }
    }

}

export type ComponentState = { [key: string]: (number | string | boolean) };
